import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Network } from "@capacitor/network";
import { AuthService } from "@core/auth.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { TranslateService } from "@ngx-translate/core";
import { SyndicateRepositoryService } from "../../syndicate/syndicate-repository.service";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-jackpot-trigger",
    templateUrl: "./jackpot-trigger.component.html",
    styleUrls: ["./jackpot-trigger.component.scss", "../onesignal.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class JackpotTriggerComponent implements OnInit {
  jackpotTrigger;
  isOnline: boolean = true;
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  constructor(
    private activatedRoute: ActivatedRoute,
    private snackBar: MySnackBarService,
    private syndicateService: SyndicateRepositoryService,
    private location: Location,
    public translate: TranslateService,
    private authService: AuthService
  ) {
    this.authService.selectedlanguage$.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
    this.authService.getConstantsMsg$.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
  }

  ngOnInit() {
    Network.addListener("networkStatusChange", (e) => {
      try {
        if (e?.connected) {
          this.isOnline = true;
        } else {
          this.isOnline = false;
        }
      } catch (error) {
        return error;
      }
    });

    this.activatedRoute.paramMap.subscribe(
      (data: any) => {
        this.jackpotTrigger = JSON.parse(data?.params?.jackpotTrigger);
      },
      (err) => {
        return err;
      }
    );
  }

  async makePayment() {
    if (!window.navigator.onLine) return;
    this.syndicateService.activateTrigger(this.jackpotTrigger).subscribe(
      (res: any) => {
        if (res?.status === "rejected") {
          this.authService.getConstantsMsg(res?.error_code).then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Something went wrong!",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            }
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          });
          return;
        }
        if (res?.status === "fail") {
          /* const msg = this.translatedToastMsg?.["1056"]?.[this.selectedLanguage];
          this.authService.showToast(res.message ? res.message : msg ? msg : "Something went wrong!", "Error", ""); */
          this.authService.getConstantsMsg("1056").then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Process failed",
                line_2: "",
              },
              style: {
                type: "Error",
                icon: "tick circle error.svg",
              }
            }
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          }).catch((err) =>{
            return err;
          });
        } else {
          /* this.snackBar.openSnackBar(
            res.message ? res.message : "Process has been successfuly done",
            "",
            "Success",
            "Success"
          ); */
          /* const msg = this.translatedToastMsg?.["1048"]?.[this.selectedLanguage];
          this.authService.showToast(
            res.message ? res.message : msg ? msg : "Process has been successfuly done",
            "Success",
            ""
          ); */
          this.authService.getConstantsMsg("1048").then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Process has been successfuly done",
                line_2: "",
              },
              style: {
                type: "Success",
                icon: "tick circle success.png",
              }
            }
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          })
          this.navigateToRegistrationDefault();
        }
      },
      (err) => {
        return err;
      }
    );
  }

  navigateToRegistrationDefault() {
    this.location.back();
  }
}
